import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { State } from 'src/app/reducers';
import { User } from 'src/app/store/auth/auth.models';
import { loadResumes } from 'src/app/store/resume/resume.actions';
import { ResumeItem, ResumeProps } from 'src/app/store/resume/resume.models';

@Component({
  selector: 'app-resumes-list',
  templateUrl: './resumes-list.component.html',
  styleUrls: ['./resumes-list.component.scss'],
})
export class ResumesListComponent implements OnInit {
  private destroyer$: Subject<any> = new Subject();
  loadingUserResumes$: Observable<boolean>;
  loadingUserError$: Observable<string>;
  currentUser: User;
  userResumes: ResumeItem[];

  constructor(private store: Store<State>) {
    // Attach to the store
    this.store
      .select((state) => state.auth.authenticatedUser)
      .pipe(takeUntil(this.destroyer$))
      .subscribe((user) => {
        this.currentUser = user;
        if (user) {
          // here we have got the authenticated user and we can now fetch all the assessment that user already did in the system
          // this.store.dispatch(this.loadingGoals$({ userId: user.sub }));
        }
      });

    // get all resumes builded
    this.store
      .select((state) => state.resumes.allResumes)
      .pipe(takeUntil(this.destroyer$))
      .subscribe((resumes) => {
        this.userResumes = resumes;
      });

    // loading resume
    this.loadingUserResumes$ = this.store.select(
      (state) => state.resumes.loadingResume
    );

    //retrieve resume loading error
    this.loadingUserError$ = this.store.select(
      (state) => state.resumes.loadingResumeError
    );

    // dispatch the action
    this.store.dispatch(loadResumes());
  }

  ngOnInit(): void {
  }

  getUserFullName(): string {
    return this.currentUser
      ? `${this.currentUser.given_name} ${this.currentUser.family_name}`
      : '';
  }

  ngOnDestroy(): void {
    this.destroyer$.next(false);
    this.destroyer$.complete();
  }
}
